import React, { useState, FunctionComponent, useEffect } from 'react';
import ReactDataGrid from '@inovua/reactdatagrid-community';
import '@inovua/reactdatagrid-community/index.css';
import SelectFilter from '@inovua/reactdatagrid-community/SelectFilter';
import { Link } from 'react-router-dom';
import { useGetBackofficeSchoolsQuery } from 'services/exploreApi';
import tag from './tag.json';
import { CommonHash } from 'app/types';
import CheckBox from '@inovua/reactdatagrid-community/packages/CheckBox';
import { navigateTop } from 'common/utils/index';
import styles from './Tags.module.scss';

interface Pagination {
  pages: number;
  current: number;
  total: number;
}

const defaultPage: Pagination = {
  pages: 0,
  current: 0,
  total: 0,
};

const gridStyle = { minHeight: 550 };
const columns = [
  { name: 'id', header: 'ID', type: 'number', defaultWidth: 60 },
  {
    name: 'logo',
    defaultFlex: 1,
    header: 'LOGO',
    render: ({ value }: { value: string }) => {
      return <img className="school-logo" src={value} />;
    },
  },
  { name: 'name', defaultFlex: 1, header: 'SCHOOL NAME' },
  {
    name: 'partner',
    defaultFlex: 1,
    header: 'PARTNER STATUS',
    // filterEditor: SelectFilter,
    // filterEditorProps: {
    //   placeholder: 'All',
    //   dataSource: [
    //     { label: 'Partner - direct', id: 'direct' },
    //     { label: 'Non-Partner', id: 'Non-Partner' },
    //   ],
    // },
    render: ({ data }: { data: CommonHash }) => {
      return (
        <span className={`badge ${data.is_partner ? 'text-bg-warning' : 'text-bg-light'}`}>
          {data.is_partner ? `Partner - ${data.partner_type}` : 'Non-Partner'}
        </span>
      );
    },
  },
  {
    name: 'locations',
    defaultFlex: 1,
    header: 'LOCATION',
    render: ({ value }: { value: string[] }) => {
      return <span className="badge text-bg-light me-1">{value}</span>;
    },
  },
  {
    name: 'is_visible',
    defaultFlex: 1,
    header: 'STATUS',
    filterEditor: SelectFilter,
    filterEditorProps: {
      placeholder: 'All',
      dataSource: [
        { label: 'Visible', id: true },
        { label: 'Hidden', id: false },
      ],
    },
    render: ({ value }: { value: boolean }) => {
      return (
        <span className={`badge ${value ? 'text-bg-success' : 'text-bg-light'}`}>
          {value ? `Visible` : 'Hidden'}
        </span>
      );
    },
  },
  {
    name: 'action',
    defaultFlex: 1,
    header: 'ACTIONS',
    render: ({ data }: { data: CommonHash }) => {
      return (
        <div>
          <Link to={`/backoffice/tags/${data.id}`}>
            <i className="bi bi-eye" />
          </Link>
        </div>
      );
    },
  },
];

const filterValue = [
  { name: 'name', operator: 'startsWith', type: 'string', value: '' },
  { name: 'partner', operator: 'eq', type: 'select', value: '', active: false },
  { name: 'locations', operator: 'startsWith', type: 'string', value: '' },
  { name: 'is_visible', operator: 'eq', type: 'select', value: '' },
];

const Tags: FunctionComponent = () => {
  const [searchFilters, setSearchFilters] = useState<{ [k: string]: any }>({});
  const [pagination, setPagination] = useState<Pagination>(defaultPage);
  const [activateRowOnFocus, setActivateRowOnFocus] = useState(true);
  const { data: schools, isLoading: schoolsLoading } = useGetBackofficeSchoolsQuery({
    ...searchFilters,
    page: pagination.current,
  });

  const onFilterChange = (key: string, value: any) => {
    if (!value) {
      setSearchFilters(({ [key]: _, ...rest }) => rest);
    } else {
      setSearchFilters((sf) => ({ ...sf, [key]: value }));
    }
  };

  const changePageSchools = (page: number) => {
    setPagination((pp) => ({ ...pp, current: page }));
    navigateTop();
  };

  useEffect(() => {
    if (schools?.meta) setPagination(schools.meta);
  }, [schools]);

  return (
    <div className={styles.tagsIndex}>
      <p>Navigate with Tab key</p>
      <div style={{ marginBottom: 20 }}>
        <CheckBox checked={activateRowOnFocus} onChange={setActivateRowOnFocus}>
          Activate row on focus
        </CheckBox>
      </div>
      <ReactDataGrid
        idProperty="id"
        style={gridStyle}
        activateRowOnFocus={activateRowOnFocus}
        columns={columns}
        rowHeight={71}
        dataSource={schools ? schools.data : []}
        pagination="local"
        defaultFilterValue={filterValue}
      />
    </div>
  );
};

export default Tags;
